/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'

import {useAuth} from '../core/Auth'
import {
  login as loginAPI,
  getLoggedUser as getLoggedUserAPI,
  checkCode,
  resetPassword,
} from '../../../../services/auth'
import {useIntl} from 'react-intl'

const resetSchema = Yup.object().shape({
  code: Yup.string().required("Il campo codice è obbligatorio"),
  password: Yup.string().required("Il campo password è obbligatorio").min(9, "La password deve essere di almeno 9 caratteri"),
  password_confirm: Yup.string()
    .required("Il campo conferma password è obbligatorio")
    .oneOf([Yup.ref('password')], "La password di conferma deve corrispondere alla password"),
})

const initialValues = {
  code: '',
  password: '',
  password_confirm: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function ResetPassword() {
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const [resetted, setResetted] = useState(false)
  const intl = useIntl()
  const formik = useFormik({
    initialValues,
    validationSchema: resetSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const checkCodeResponse = await checkCode(values.code)
        if (checkCodeResponse.success == 0) {
          setLoading(false)
          setSubmitting(false)
          setStatus("Codice non valido")
          return
        }

        const auth = await resetPassword(values.code, values.password, values.password_confirm)
        if (auth.success == 0) {
          setLoading(false)
          setSubmitting(false)
          setStatus("Codice non valido")
          return
        }
        setLoading(false)
        setStatus('')
        //const {data: auth} = await login(values.email, values.password)

        setResetted(true)
        /*
        console.log("data", auth)
       
        
        const {data: user} = await getUserByToken(auth.api_token)
       

        */
      } catch (error) {
        /*
        console.error(error)
        saveAuth(undefined)
        setStatus(intl.formatMessage({id: 'AUTH.USERNAME_PASSWORD_INVALID'}))
        setSubmitting(false)
        setLoading(false)
        */
      }
    },
  })

  return (
    <>
      <form
        className='form w-100'
        onSubmit={formik.handleSubmit}
        noValidate
        id='kt_login_signin_form'
      >
        {/* begin::Heading */}
        <div className='text-center mb-11'>
          <h1 className='text-dark fw-bolder mb-3'>
          Reimposta password
          </h1>
          <div className='text-gray-500 fw-semibold fs-6'>Insight</div>
        </div>
        {/* begin::Heading */}

        {resetted ? (
          <>
            <div className='mb-lg-15 alert alert-success'>
              <div className='alert-text font-weight-bold'>
              La password è stata reimpostata con successo.
              </div>
            </div>

            <Link to='/auth' className='btn btn-primary' style={{width: '100%'}}>
            Vai alla pagina di login
            </Link>
          </>
        ) : (
          <>
            <div className='mb-10 bg-light-info p-8 rounded'>
              <div className='text-info'>
              Un'email è stata inviata al tuo indirizzo email con il codice per reimpostare la tua password.
              </div>
            </div>
            {formik.status ? (
              <div className='mb-lg-15 alert alert-danger'>
                <div className='alert-text font-weight-bold'>{formik.status}</div>
              </div>
            ) : (
              <></>
            )}
            <div className='fv-row mb-8'>
              <label className='form-label fs-6 fw-bolder text-dark'>
                Codice
              </label>
              <input
                placeholder="Codice"
                {...formik.getFieldProps('code')}
                className={clsx(
                  'form-control bg-transparent',
                  {'is-invalid': formik.touched.code && formik.errors.code},
                  {
                    'is-valid': formik.touched.code && !formik.errors.code,
                  }
                )}
                type='text'
                name='code'
                autoComplete='off'
              />

              {formik.touched.code && formik.errors.code && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>
                      {intl.formatMessage(
                        {id: formik.errors.code},
                        {field: "Codice"}
                      )}
                    </span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='fv-row mb-8'>
              <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
              <input
                type='password'
                autoComplete='off'
                placeholder='Password'
                {...formik.getFieldProps('password')}
                className={clsx(
                  'form-control bg-transparent',
                  {
                    'is-invalid': formik.touched.password && formik.errors.password,
                  },
                  {
                    'is-valid': formik.touched.password && !formik.errors.password,
                  }
                )}
              />
              {formik.touched.password && formik.errors.password && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>
                      {intl.formatMessage({id: formik.errors.password}, {field: 'Password'})}
                    </span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='fv-row mb-3'>
              <label className='form-label fw-bolder text-dark fs-6 mb-0'>
                Conferma password
              </label>
              <input
                type='password'
                autoComplete='off'
                placeholder='Password'
                {...formik.getFieldProps('password_confirm')}
                className={clsx(
                  'form-control bg-transparent',
                  {
                    'is-invalid': formik.touched.password_confirm && formik.errors.password_confirm,
                  },
                  {
                    'is-valid': formik.touched.password_confirm && !formik.errors.password_confirm,
                  }
                )}
              />
              {formik.touched.password_confirm && formik.errors.password_confirm && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>
                      {intl.formatMessage(
                        {id: formik.errors.password_confirm},
                        {field: "Conferma password"}
                      )}
                    </span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Form group */}

            {/* begin::Action */}
            <div className='d-grid mb-3'>
              <button
                type='submit'
                id='kt_sign_in_submit'
                className='btn btn-primary'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {!loading && (
                  <span className='indicator-label'>
                    Reimposta password
                  </span>
                )}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            {/* end::Action */}
          </>
        )}
      </form>
    </>
  )
}
